import {computed, inject, Injectable, signal} from '@angular/core';
import {ApiService} from './api.service';
import {catchError, EMPTY, switchMap, tap} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {AUTH_KEYS} from './auth-constants';
import {LoadingService} from './loading.service';

interface IUser {
}

@Injectable({providedIn: 'root'})
export class AuthService {
  apiService = inject(ApiService);
  loadingService = inject(LoadingService);
  router = inject(Router)
  private userSignal = signal<any>(null);
  user = computed(() => this.userSignal());

  constructor() {
    console.log("start auth service")
  }

  Register(data: any) {
    return this.apiService.SendPost('/user/register', data, this.loadingService.StatesNames.REGISTER).pipe(
      tap((res) => {
        localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, res[AUTH_KEYS.ACCESS_TOKEN]);
        localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN, res[AUTH_KEYS.REFRESH_TOKEN]);
        this.userSignal.set(data);
      })
    )
  }

  HasTokens() {
   return localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN) && localStorage.getItem(AUTH_KEYS.REFRESH_TOKEN)

  }

  RequestPassword(data: any) {
    return this.apiService.SendPost('/user/request-reset', data, this.loadingService.StatesNames.REQUEST_PASSWORD).pipe(
      tap((res) => {
      })
    )
  }

  RestorePassword(data: any) {
    return this.apiService.SendPost('/user/reset-password', data, this.loadingService.StatesNames.RESTORE_PASSWORD).pipe(
      tap((res) => {
      })
    )
  }

  Login(data: any) {
    return this.apiService.SendPost('/user/auth', data, this.loadingService.StatesNames.LOGIN).pipe(
      tap((res) => {
        localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, res[AUTH_KEYS.ACCESS_TOKEN]);
        localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN, res[AUTH_KEYS.REFRESH_TOKEN]);
        this.userSignal.set({...res['data'],subscription:res['subscription']});
      })
    );
  }

  GetMe() {
    return this.apiService.SendGet('/user/me')
      .pipe(
        catchError((err)=>{
          this.router.navigate(['/auth'])
          this.CLearSession();
          return EMPTY;

        }),
        tap((res) => {
          this.userSignal.set(res);
          if(window.location.href.includes('auth')){
            this.router.navigate(['/base'])
          }

        }
    )
      )
  }

  DoPromocode(promoCode: string) {
    return this.apiService.SendPost(`/user/promo-codes/use?code=${promoCode}`, {})
      .pipe(
        switchMap(() => {
            return this.GetMe()
          }
        )
      )
  }

  RefreshToken() {
    return this.apiService.SendPost('/user/refresh', {}).pipe(tap((res) => {
      localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, res['jwt']);
      localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN, res['refresh']);
      this.userSignal.set(res['data']);
    }))
  }


  CLearSession() {
    localStorage.removeItem(AUTH_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(AUTH_KEYS.REFRESH_TOKEN);
    this.userSignal.set(null);
  }

  logout() {
    return this.apiService.SendPost('/user/logout', {}).pipe(
      tap(() => {
        this.CLearSession();
        this.router.navigate(['/auth']);
      })
    )
  }
}
